// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".log[data-v-5d293472] {\n  padding: 5px;\n  height: 100%;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  flex: 1;\n  background-color: white;\n}\n.log__body[data-v-5d293472] {\n  overflow: auto;\n  height: 100%;\n}\n.frame[data-v-5d293472] {\n  border: 1px solid lightgray;\n}\n.like[data-v-5d293472] {\n  cursor: pointer;\n  font-size: 25px;\n  display: inline-block;\n}", ""]);
// Exports
module.exports = exports;
